import {
  TradeProgramAgreement,
  getStaticProps,
} from 'routes/public/TradeProgramAgreement'

export { getStaticProps }

export default TradeProgramAgreement
